
  var _styles = {
  "operate-btns__container": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "space-between",
    "width": "8.72rem"
  },
  "operate-btns__button": {
    "height": "1.17333rem",
    "borderRadius": "1.06667rem",
    "display": "flex",
    "flexDirection": "row",
    "justifyContent": "center",
    "alignItems": "center"
  },
  "operate-btns__text": {
    "color": "rgb(255,255,255)",
    "fontFamily": "PingFang SC",
    "fontWeight": "600",
    "fontSize": "0.42667rem"
  },
  "draw-btns__container": {
    "display": "flex",
    "flexDirection": "row",
    "justifyContent": "center",
    "alignItems": "center"
  },
  "draw-btns__subscript": {
    "color": "rgb(64,21,2)",
    "fontFamily": "PingFang SC",
    "fontWeight": "600",
    "fontSize": "0.26667rem",
    "textAlign": "left"
  }
};



  module.exports = _styles;
  